import React from 'react';
import { UseFormHandleSubmit } from 'react-hook-form';
import { HealtheraButton } from '../../../../../../healtheraComponents';
import { Questionnaire } from '../../../../types';
import { useCreateQuestionnaire } from '../hooks/useSubmitQuestionnaire';
import { useSelector } from 'react-redux';
import { selectIsEditingAnyQuestion, selectQuestions } from '../../../../../../redux/questionnaire/selectors';
import { enqueueSnackbar } from 'notistack';

interface Props {
  handleSubmit: UseFormHandleSubmit<Questionnaire>;
}

const CreateButton = ({ handleSubmit }: Props) => {
  const { createQuestionnaire, isLoading } = useCreateQuestionnaire();
  const questions = useSelector(selectQuestions);
  const isEditingAnyQuestion = useSelector(selectIsEditingAnyQuestion);

  const createQuestionnaireWithChecks = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (questions.length === 0) {
      enqueueSnackbar('You need to add at least one question to create a questionnaire', { variant: 'error' });
      return;
    }

    if (isEditingAnyQuestion) {
      enqueueSnackbar('You need to finish editing the question before creating a questionnaire', { variant: 'error' });
      return;
    }

    handleSubmit(createQuestionnaire)(e);
  };

  return (
    <HealtheraButton disabled={isLoading} onClick={createQuestionnaireWithChecks}>
      Create questionnaire
    </HealtheraButton>
  );
};
export default CreateButton;
